<template>
  <div class="p-page-wrapper">
    <p-routed-tabs
      :tabs="tabs"
      class="pt-1"
    ></p-routed-tabs>
    <router-view/>
  </div>
</template>


<script>
import PRoutedTabs from '@/components/PRoutedTabs'

import pageMixin from '@/mixins/page.mixin'


export default {
  components: {
    PRoutedTabs
  },


  mixins: [
    pageMixin
  ],


  data () {
    return {
      tabs: [
        { title: this.$t('settings.tabs.users'), route: 'settingsUsers' },
        { title: this.$t('settings.tabs.billing'), route: 'settingsBilling' },
        { title: this.$t('settings.tabs.seasons'), route: 'settingsSeasons' },
        { title: this.$t('settings.tabs.contractTemplates'), route: 'settingsContractTemplates' },
        { title: this.$t('settings.tabs.scheduleTemplates'), route: 'settingsScheduleTemplates' },
        { title: this.$t('settings.tabs.budgetCategories'), route: 'settingsBudgetCategories' },
        { title: this.$t('settings.tabs.eventCategories'), route: 'settingsEventCategories' },
        { title: this.$t('settings.tabs.tenant'), route: 'settingsTenant' }
      ]
    }
  },


  created () {
    this.setPageTitle(this.$t('nav.settings'))
  }
}
</script>
